module.exports = __webpack_public_path__ + "static/media/tcs_logo.358fe803.png";